import React from 'react';
import type { SubmissionScanMethod } from '../services/trungTamApi';

type Props = {
  method: SubmissionScanMethod | null | undefined;
  /** compact = small pill (table cell); default = chip with label */
  size?: 'compact' | 'default';
};

/**
 * Surfaces how a record was acquired (qr / ocr / manual). QR is trusted
 * (green) because it came straight from the CCCD chip; OCR is flagged
 * (amber) because Mistral output can contain recognition errors; manual
 * is neutral. Used in NVTT queue, NVTT detail popup, and the teacher's
 * own "Hồ sơ đã nộp" list so both sides see the same trust signal.
 */
const CONFIG: Record<SubmissionScanMethod, { label: string; tooltip: string; icon: string; variant: string }> = {
  qr: {
    label: 'QR',
    tooltip: 'Dữ liệu đọc trực tiếp từ QR của CCCD — chính xác 100%',
    icon: 'qr_code_2',
    variant: 'qr',
  },
  ocr: {
    label: 'OCR',
    tooltip: 'Dữ liệu nhận dạng bằng OCR từ ảnh CCCD — hãy đối chiếu lại',
    icon: 'document_scanner',
    variant: 'ocr',
  },
  manual: {
    label: 'Thủ công',
    tooltip: 'Dữ liệu nhập tay — không có nguồn gốc CCCD',
    icon: 'edit',
    variant: 'manual',
  },
};

const ScanMethodBadge: React.FC<Props> = ({ method, size = 'default' }) => {
  if (!method) return null;
  const cfg = CONFIG[method] || CONFIG.ocr;
  return (
    <span
      className={`tt-scan-badge tt-scan-badge--${cfg.variant}${size === 'compact' ? ' tt-scan-badge--compact' : ''}`}
      title={cfg.tooltip}
    >
      <i className="material-icons">{cfg.icon}</i>
      {cfg.label}
    </span>
  );
};

export default ScanMethodBadge;
